// @flow

export const getElementMetadataPairs = (
  meta: string,
  doc: Document = document
): Array<{ element: Element, solMetadata: * }> => {
  const elements = doc.querySelectorAll(`[${meta}]`);
  const elementsArray = [].slice.call(elements);

  return elementsArray
    .map(element => {
      const solMetadata = JSON.parse(element.getAttribute(meta) || '{}');
      return { element, solMetadata };
    })
    .filter(elem => elem);
};
